'use client';

import { useQuery } from '@tanstack/react-query';

import { useSupabase } from '@kit/supabase/hooks/use-supabase';

/**
 * Hook to check if the current user is a super admin
 *
 * Uses the database is_super_admin() function which checks JWT app_metadata.role
 * Results are cached for 5 minutes to avoid repeated RPC calls
 *
 * @returns Query result with boolean indicating super admin status
 */
export function useIsSuperAdmin() {
  const client = useSupabase();

  return useQuery({
    queryKey: ['is-super-admin'],
    queryFn: async () => {
      const { data, error } = await client.rpc('is_super_admin');

      if (error) {
        console.error('Error checking super admin status:', error);
        return false;
      }

      return !!data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    retry: 1, // Only retry once on failure
    refetchOnWindowFocus: false, // Don't refetch on window focus
  });
}
